__turbopack_context__.v({
  "container": "FAQSection-module-scss-module__5s2_9q__container",
  "section": "FAQSection-module-scss-module__5s2_9q__section",
  "tabs": "FAQSection-module-scss-module__5s2_9q__tabs",
});
